import { render, staticRenderFns } from "./lifeExpertDetail.vue?vue&type=template&id=66db1b33&scoped=true"
import script from "./lifeExpertDetail.vue?vue&type=script&lang=js"
export * from "./lifeExpertDetail.vue?vue&type=script&lang=js"
import style0 from "./lifeExpertDetail.vue?vue&type=style&index=0&id=66db1b33&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66db1b33",
  null
  
)

export default component.exports